// This import needs to be the first one to avoid C_I's.
// Setting up the runtime public path is needed for all
// resources that are fetched dynamically in runtime.
import "init-webpack-base-url";
import "core-js/features/object/assign";
import GRAY_LOGO from "assets/images/gray-logo.svg";
import SUPPORTED_BROWSERS from "assets/images/supported-browsers.svg";
import * as React from "react";
import ReactDOM, { unmountComponentAtNode } from "react-dom";
import { isMobileDevice, isSupportedBrowser } from "util/supported-device";
import { Button } from "view/common/overrides/button";
import { ExternalLink } from "view/common/overrides/external-link";
import "./block-browser.scss";
const UnsupportedBrowserPage = ({ image, title, description, actions, }) => {
    let actionsNode;
    if (actions) {
        actionsNode = React.createElement("div", { className: "actions" }, actions);
    }
    return (React.createElement("div", { className: "unsupported-browser-page" },
        React.createElement("img", { alt: "SingleStore Studio", src: GRAY_LOGO }),
        React.createElement("div", { className: "content" },
            React.createElement("img", { alt: "SingleStore Studio", src: image }),
            React.createElement("div", { className: "title" }, title),
            React.createElement("div", { className: "description" }, description),
            actionsNode)));
};
const reactRoot = document.getElementById("react-root");
if (reactRoot) {
    // We clear up what is in #react-root as early as we can to avoid users from
    // seeing the "Enable JavaScript" message in it while React is loading.
    unmountComponentAtNode(reactRoot);
    let page;
    if (isMobileDevice()) {
        page = (React.createElement(UnsupportedBrowserPage, { image: SUPPORTED_BROWSERS, title: "We only support desktop devices", description: React.createElement(React.Fragment, null, "To get the most out of SingleStore Studio, please use a laptop or desktop computer.") }));
    }
    else if (!isSupportedBrowser()) {
        page = (React.createElement(UnsupportedBrowserPage, { image: SUPPORTED_BROWSERS, title: "We only support the latest Chrome and Firefox", description: React.createElement(React.Fragment, null,
                "To get the most out of SingleStore Studio, please use the most up to date version of",
                " ",
                React.createElement(ExternalLink, { name: "chrome", category: "block-browser" }, "Chrome"),
                " ",
                "or",
                " ",
                React.createElement(ExternalLink, { name: "firefox", category: "block-browser" }, "Firefox"),
                "."), actions: React.createElement(React.Fragment, null,
                React.createElement(Button, { large: true, primary: true, externalLink: {
                        name: "chrome",
                        category: "block-browser",
                    } }, "Get Chrome (Recommended)"),
                React.createElement(Button, { large: true, externalLink: {
                        name: "firefox",
                        category: "block-browser",
                    } }, "Get Firefox")) }));
    }
    if (page) {
        ReactDOM.render(page, reactRoot);
    }
}
